import React from 'react';

/**
 * Renders a phone number in a DataGrid cell with proper RTL/LTR support.
 *
 * Uses direction: 'ltr' with unicodeBidi: 'embed' to ensure phone digits
 * display in correct order regardless of app language direction.
 * The parent container alignment follows the app's language direction.
 *
 * @param {object} props - Component props
 * @param {string} props.value - The phone number to display
 * @param {boolean} [props.showTitle=true] - Whether to show tooltip on hover
 * @returns {JSX.Element} Phone cell element
 *
 * @example
 * // In DataGrid column definition:
 * {
 *     field: 'phoneFormatted',
 *     headerName: 'Phone',
 *     renderCell: (params) => <PhoneCell value={params.value} />
 * }
 */
export const PhoneCell = ({ value, showTitle = true }) => {
    return (
        <div style={{ width: '100%' }} title={showTitle ? value : undefined}>
            <span style={{ direction: 'ltr', unicodeBidi: 'embed' }}>{value}</span>
        </div>
    );
};

export default PhoneCell;
